import { GoogleIcon, FacebookIcon, InstagramIcon, tiktokIcon, XIcon, LinkedInIcon } from 'assets/images/integrations';
import StoryRingIcon from '@components/StoryRingIcon';
import { POST_CHANNEL, normalizePlatform } from '@constants/social-posts';

const PlatformIcon = ({ platform, size = 18 }) => {
    switch (normalizePlatform(platform)) {
        case POST_CHANNEL.GOOGLE:
            return <GoogleIcon width={size} height={size} />;
        case POST_CHANNEL.FACEBOOK:
            return <FacebookIcon width={size} height={size} />;
        case POST_CHANNEL.INSTAGRAM:
            return <InstagramIcon width={size} height={size} />;
        case POST_CHANNEL.TIKTOK:
            return <img src={tiktokIcon} alt="" width={size} height={size} style={{ display: 'inline-block' }} />;
        case POST_CHANNEL.X:
            return <XIcon width={size} height={size} />;
        case POST_CHANNEL.LINKEDIN:
            return <LinkedInIcon width={size} height={size} />;
        case POST_CHANNEL.FACEBOOK_STORY:
            return (
                <StoryRingIcon size={size}>
                    <FacebookIcon />
                </StoryRingIcon>
            );
        case POST_CHANNEL.INSTAGRAM_STORY:
            return (
                <StoryRingIcon size={size}>
                    <InstagramIcon />
                </StoryRingIcon>
            );
        default:
            return null;
    }
};

export default PlatformIcon;
